/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
export const BriefcaseMedicalIconConfig = {
  name: 'BriefcaseMedicalIcon',
  height: 512,
  width: 512,
  svgPath: 'M464 128h-80V80c0-26.5-21.5-48-48-48H176c-26.5 0-48 21.5-48 48v48H48c-26.5 0-48 21.5-48 48v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48zM192 96h128v32H192V96zm160 248c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48z',
  yOffset: '',
  xOffset: '',
  transform: ''
};
export default createIcon(BriefcaseMedicalIconConfig);
//# sourceMappingURL=briefcase-medical-icon.js.map